'use client'
import {default as Image} from '@/components/global/images/resized-cdn-image';
import { useParams } from 'next/navigation';
import React, { useState } from 'react';

import { doTranslation } from '@/app/i18n/client';

import styles from '@/components/global/notification/notification.module.scss';

import closeDark from '@/public/assets/images/global/close-dark.svg';

interface Props extends React.AllHTMLAttributes<HTMLDivElement> {}

const Notification = (props: Props): React.JSX.Element | null => {
  const { lng } = useParams() as { lng: string };
  const { t } = doTranslation(lng);

  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.notification}>
      {props.children}
      <button className={styles.button} onClick={() => setIsOpen(false)} type="button">
        <Image alt={t('Close')} className={styles.img} height="18" src={closeDark} width="18" priority={true} />
      </button>
    </div>
  );
};

export default Notification;
